import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { MobileNav } from '../components/MobileNav';
import { X, Copy, Link2 } from 'lucide-react';
export function DecodeSaveShare() {
  const navigate = useNavigate();
  const [showShareModal, setShowShareModal] = useState(false);
  const [saved, setSaved] = useState(false);
  const [copiedText, setCopiedText] = useState(false);
  const [copiedLink, setCopiedLink] = useState(false);
  const handleSave = () => {
    // Placeholder for save functionality
    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  };
  const handleDoNothing = () => {
    navigate('/');
  };
  const handleCopyText = () => {
    const text = 'A pattern I noticed: the gap between public capability and private exhaustion. The friction comes from holding it all together.';
    navigator.clipboard.writeText(text);
    setCopiedText(true);
    setTimeout(() => setCopiedText(false), 2000);
  };
  const handleCopyLink = () => {
    navigator.clipboard.writeText(window.location.origin);
    setCopiedLink(true);
    setTimeout(() => setCopiedLink(false), 2000);
  };
  return <>
      <Helmet data-id="element-1137">
        <title data-id="element-1138">Save or Share | Lazy Monk Labs</title>
      </Helmet>

      <div className="min-h-screen bg-[#0A0A0A] text-[#F5F5F5]" data-id="element-1139">
        <MobileNav data-id="element-1140" />

        <main className="pt-20 sm:pt-24 pb-20 sm:pb-28" data-id="element-1141">
          <div className="max-w-2xl mx-auto px-6 sm:px-8" data-id="element-1142">
            {/* PAGE TITLE */}
            <section className="py-12 sm:py-16 text-center" data-id="element-1143">
              <h1 className="text-2xl sm:text-3xl leading-tight text-[#F5F5F5] mb-6" style={{
              fontFamily: 'Georgia, serif'
            }} data-id="element-1144">
                What would you like to do with this?
              </h1>
              <div className="space-y-4 max-w-md mx-auto" data-id="element-1145">
                <p className="text-base text-gray-500 leading-relaxed" data-id="element-1146">
                  Some recognitions are meant to be kept. Others are useful to
                  name — for yourself, or with someone you trust.
                </p>
                <p className="text-base text-gray-500 leading-relaxed" data-id="element-1147">
                  You can decide what this becomes.
                </p>
              </div>
            </section>

            {/* OPTIONS */}
            <section className="py-8 sm:py-12 max-w-md mx-auto space-y-4" data-id="element-1148">
              {/* OPTION 1: SAVE */}
              <button onClick={handleSave} className="w-full px-6 py-5 border border-[#2B2B2B] text-left hover:border-gray-500 transition-colors group" data-id="element-1149">
                <div className="flex flex-col gap-1" data-id="element-1150">
                  <span className="text-sm font-medium uppercase tracking-widest text-gray-400 group-hover:text-[#F5F5F5] transition-colors" data-id="element-1151">
                    {saved ? 'Saved' : 'Save this'}
                  </span>
                  <span className="text-xs text-gray-600 group-hover:text-gray-500 transition-colors" data-id="element-1152">
                    Keep a private record of this decode.
                  </span>
                </div>
              </button>

              {/* OPTION 2: SHARE */}
              <button onClick={() => setShowShareModal(true)} className="w-full px-6 py-5 border border-[#2B2B2B] text-left hover:border-gray-500 transition-colors group" data-id="element-1153">
                <div className="flex flex-col gap-1" data-id="element-1154">
                  <span className="text-sm font-medium uppercase tracking-widest text-gray-400 group-hover:text-[#F5F5F5] transition-colors" data-id="element-1155">
                    Share a reflection
                  </span>
                  <span className="text-xs text-gray-600 group-hover:text-gray-500 transition-colors" data-id="element-1156">
                    Share a short, anonymised excerpt.
                  </span>
                </div>
              </button>

              {/* OPTION 3: DO NOTHING */}
              <button onClick={handleDoNothing} className="w-full px-6 py-5 border border-[#2B2B2B] text-left hover:border-gray-500 transition-colors group" data-id="element-1157">
                <div className="flex flex-col gap-1" data-id="element-1158">
                  <span className="text-sm font-medium uppercase tracking-widest text-gray-400 group-hover:text-[#F5F5F5] transition-colors" data-id="element-1159">
                    Nothing for now
                  </span>
                  <span className="text-xs text-gray-600 group-hover:text-gray-500 transition-colors" data-id="element-1160">
                    You can come back to this later.
                  </span>
                </div>
              </button>
            </section>
          </div>
        </main>

        {/* SHARE MODAL */}
        {showShareModal && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" data-id="element-1161">
            <div className="bg-[#111214] border border-[#2B2B2B] w-full max-w-md p-6 sm:p-8 relative" data-id="element-1162">
              <button onClick={() => setShowShareModal(false)} className="absolute top-4 right-4 text-gray-500 hover:text-[#F5F5F5] transition-colors" data-id="element-1163">
                <X className="w-5 h-5" data-id="element-1164" />
              </button>

              <div className="space-y-6" data-id="element-1165">
                <h2 className="text-xl text-[#F5F5F5]" style={{
              fontFamily: 'Georgia, serif'
            }} data-id="element-1166">
                  Share a reflection
                </h2>

                <div className="bg-[#0A0A0A] border border-[#2B2B2B] p-6 text-gray-400 text-sm leading-relaxed italic" data-id="element-1167">
                  "A pattern I noticed: the gap between public capability and
                  private exhaustion. The friction comes from holding it all
                  together."
                </div>

                <div className="flex flex-col gap-3" data-id="element-1168">
                  <button onClick={handleCopyText} className="flex items-center justify-center gap-2 w-full px-4 py-3 border border-[#2B2B2B] text-gray-400 text-xs font-medium uppercase tracking-widest hover:text-[#F5F5F5] hover:border-gray-500 transition-colors" data-id="element-1169">
                    <Copy className="w-4 h-4" data-id="element-1170" />
                    {copiedText ? 'Copied' : 'Copy text'}
                  </button>

                  <button onClick={handleCopyLink} className="flex items-center justify-center gap-2 w-full px-4 py-3 border border-[#2B2B2B] text-gray-400 text-xs font-medium uppercase tracking-widest hover:text-[#F5F5F5] hover:border-gray-500 transition-colors" data-id="element-1171">
                    <Link2 className="w-4 h-4" data-id="element-1172" />
                    {copiedLink ? 'Link copied' : 'Copy link'}
                  </button>
                </div>

                <div className="pt-4 border-t border-[#2B2B2B] text-center" data-id="element-1173">
                  <p className="text-[10px] text-gray-600 uppercase tracking-wider" data-id="element-1174">
                    Shared from Lazy Monk Labs
                  </p>
                </div>
              </div>
            </div>
          </div>}
      </div>
    </>;
}